import { lazyRouteComponent } from "@tanstack/react-router";




const Login = lazyRouteComponent(() => import("./login.view"), "Login");

export const routeOptions = {
  component: Login,
  validateSearch: (s: Record<string, unknown>): { next?: string } => ({
    next: typeof s.next === "string" && s.next.startsWith("/") && !s.next.startsWith("//")
      ? s.next
      : undefined,
  }),

  head: () => ({
    meta: [
      { title: "Logga in – Alkoholprovet" },
      { name: "description", content: "Logga in på Alkoholprovet med e-post eller magisk länk för att fortsätta öva inför kunskapsprovet och se din statistik." },
      { name: "robots", content: "noindex" },
    ],
  }),
};
